export const formatDurationToMonthsAndDays = (duration: Duration): string => {
  const meses = duration.months + duration.years * 12
  const dias = 'dia'.pluralizeAndConcatValue(duration.days)
  const mesPlural = meses === 1 ? 'mês' : 'meses'
  const mesString = meses > 0 ? `${meses} ${mesPlural} e ` : ''
  return `Há ${mesString}${dias}`
}
